<footer>
    <div class="max_width_footer">
        <div class="logo_impressum">
            <a href="">
                <img src="../../assets/img/introduce/logo_name.png">
            </a>
            <div class="impressum">
                <a href="impressum">
                    {{translateText.footerText[translateText.language]['imprint']}}
                </a>
                <div class="underline"></div>
            </div>
        </div>
        <span>© Jan Horstmann 2024</span>
        <div class="contact_sides">
            <a href="https://github.com/JanTHorstmann?tab=repositories" target="_blank">
                <img src="../../assets/img/introduce/github.png">
            </a>
            <a href="#app-contact-form">
                <img src="../../assets/img/introduce/mail.png">
            </a>
            <a href="https://www.linkedin.com/in/jan-t-horstmann/" target="_blank">
                <img src="../../assets/img/introduce/linkedin.png">
            </a>
        </div>
    </div>
</footer>